import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDevice from "./base";

export default class PoolDeviceFilter extends PoolDevice implements PoolDeviceInterface {
    static CanBeAddedToflow = true;
    static Icon = "filter";
    static DeviceType = DeviceTypes.FILTER;
    static PickerTitle = Locale.gettext("Filter");
}
